<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
      <!--begin::sidebar-->
      <sidebar-component classMenu="PointersOfMonthDetail"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
               <div class="card-header">
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                     Detail Pointer of Month
                  </h6>

                  <button
                    class="btn btn-light float-end"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseExample"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                  >
                    <i class="link-icon" data-feather="info"></i>
                    Audit Info
                  </button>

                  <div
                    class="row mb-3 collapse"
                    id="collapseExample"
                    style="padding-left: 20px"
                  >
                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created By:</label>
                      <p class="text-muted">{{ this.forms.created_by }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created At:</label>
                      <p class="text-muted">{{ this.forms.created_at }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                      <p class="text-muted">{{ this.forms.updated_by }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                      <p class="text-muted">{{ this.forms.updated_at }}</p>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label class="col-form-label" style="padding-left: 25px">User</label>
                    </div>
                    <div class="col-lg-8">
                      <div class="d-flex align-items-center">
                        <img
                          :src="getUserImage(forms.user)"
                          alt="User"
                          class="rounded-circle me-3"
                          style="width: 60px; height: 60px; object-fit: cover"
                        />
                        <div>
                          <h6 class="mb-0">{{ forms.user?.name }}</h6>
                          <small class="text-muted">{{ forms.user?.email }}</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label class="col-form-label" style="padding-left: 25px">Month/Year</label>
                    </div>
                    <div class="col-lg-8">
                      <p class="form-control-plaintext">{{ formatMonthYear(forms.month_year) }}</p>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label class="col-form-label" style="padding-left: 25px">Status</label>
                    </div>
                    <div class="col-lg-8">
                      <span :class="forms.is_active ? 'badge bg-success' : 'badge bg-secondary'">
                        {{ forms.is_active ? 'Active' : 'Inactive' }}
                      </span>
                    </div>
                  </div>

                  <div class="row mb-3" v-if="forms.description">
                    <div class="col-lg-2">
                      <label class="col-form-label" style="padding-left: 25px">Description</label>
                    </div>
                    <div class="col-lg-8">
                      <p class="form-control-plaintext">{{ forms.description }}</p>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label class="col-form-label" style="padding-left: 25px">Display Image</label>
                    </div>
                    <div class="col-lg-8">
                      <img 
                        :src="getDisplayImage(forms)" 
                        alt="Display Image" 
                        class="img-thumbnail"
                        style="max-width: 300px; max-height: 300px;"
                      />
                      <br>
                      <small class="text-muted">
                        {{ forms.custom_image ? 'Custom uploaded image' : 'Using user profile image' }}
                      </small>
                    </div>
                  </div>

                  <div class="card-footer">
                    <button
                      class="
                        btn btn-warning
                        text-black
                        fw-bolder
                        btn-icon-text
                      "
                      @click="backForm"
                      type="button"
                    >
                      <i class="link-icon" data-feather="arrow-left"></i>
                      {{ $t("backMess") }}
                    </button>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      v-if="permision_role.method_update"
                      class="btn btn-primary btn-sm"
                      @click="editData"
                      type="button"
                    >
                      <i class="link-icon" data-feather="edit"></i>
                      Edit
                    </button>
                  </div>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "PointersOfMonthDetail",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {      
      isLoading: false,      
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      permision_role: [],
      userData: "",
      forms: {},
      pointerId: null,
    };
  },
  watch: {},
  methods: {
    backForm() {
      window.location.href = "/pointers-of-month";
    },

    cek_message(status, msg) {
      if (status == "200") {
        this.success(msg);
      }
    },

    editData() {
      var params = this.$onRandom(this.pointerId);
      window.location.href = "/pointers-of-month/edit/" + params;
    },

    getUserImage(user) {
      if (user?.image) {
        return user.image;
      }
      return require('@/assets/maternity.png');
    },
    
    getDisplayImage(item) {
      if (item.custom_image) {
        return item.custom_image;
      }
      return this.getUserImage(item.user);
    },
    
    formatMonthYear(monthYear) {
      if (!monthYear) return '';
      const date = new Date(monthYear + '-01');
      return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long' 
      });
    },

    fetchData() {
      this.isLoading = true;
      const baseURI = this.$settings.endPoint + "pointers-of-month/detail/" + this.pointerId;
      
      this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.isLoading = false;
          if (response.data.status === 200) {
            this.forms = response.data.datas;
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch(error => {
          this.isLoading = false;
          if(error.code == "ECONNABORTED"){
            this.error("Please Check Your Internet Connection");
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000);
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "PointersOfMonthController") {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {
    var params = this.$onBehind(this.$route.params.id);
    this.pointerId = params[0];
  },
  mounted() {
    // var params = this.$onBehind(this.$route.params.id);
    this.cek_message(this.$route.query.status, this.$route.query.msg);
    this.fetchIt();
    this.fetchData();
  },
};
</script>

<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}

.blur-content{
  filter: blur(5px); 
  pointer-events: none;
}

.badge {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
}

.bg-success {
  background-color: #28a745 !important;
  color: white;
}

.bg-secondary {
  background-color: #6c757d !important;
  color: white;
}
</style>